export default __webpack_public_path__ + "static/media/trainer_3.b12c8ce2.PNG";